import React from 'react';
import { parseISO, format } from 'date-fns';
import { formatPrice } from '@micro-apps/shared';
import { pluraliseWord } from '@fshr/shared';

import { useTranslation } from '../../../hooks';

export default function ShoppingCartItemRateDetails({
	roomRate,
	currencyCode,
	stayResortFees,
	taxAndFees,
}) {
	const { t } = useTranslation();
	return (
		<div className="rate-details">
			<div className="rate-details__top">
				<div className="rate-details__top__pair">
					<span className="detailD4">{t('Average Nightly Rate')}</span>
					<span className="rate-details__pair__price">
						{formatPrice({
							currencyCode,
							value: roomRate?.averageNightlyPrice.cash.amount,
						})}
					</span>
				</div>
				<div className="detailD4 rate-details__top__taxes">{t(taxAndFees)}</div>
			</div>
			<div className="ty-d4">{`${t('Daily Rates')} | ${pluraliseWord(
				roomRate?.nightlyRates?.length,
				t('Night'),
				t('Nights')
			)}`}</div>
			<div className="rate-details__list">
				{roomRate?.nightlyRates.map(({ date, cash, resortFees }) => {
					return (
						<React.Fragment key={date}>
							<div className="rate-details__pair">
								<span className="ty-d4">{format(parseISO(date), 'EEEE, MMM dd')}</span>
								<span className="rate-details__pair__price">
									{formatPrice({
										currencyCode,
										value: cash.amount,
									})}
								</span>
							</div>
							{resortFees?.length > 0 &&
								resortFees?.map(({ code, description, cash }) => {
									return (
										<div className="rate-details__pair" key={code}>
											<span className="ty-d4">{`+ ${description}`}</span>
											<span className="rate-details__pair__price">
												{formatPrice({
													currencyCode,
													value: cash.amount,
												})}
											</span>
										</div>
									);
								})}
						</React.Fragment>
					);
				})}
				{stayResortFees &&
					stayResortFees.map(({ code, description, cash }) => {
						return (
							<div className="rate-details__pair" key={code}>
								<span className="ty-d4">{description}</span>
								<span className="rate-details__pair__price">
									{formatPrice({
										currencyCode,
										value: cash.amount,
									})}
								</span>
							</div>
						);
					})}
			</div>
		</div>
	);
}
